import { FormAdapter, FormAlert, FormContainerOptions, FormControlType, FormValues } from '@omegagrid/form';
import { Service } from '@reporting/rp-app-host';
import { File } from '@reporting/rp-types/etl';
import { msg } from '@omegagrid/localize';
import { delimiters, encodings, quotes } from '../types';

export class FileFormAdapter extends FormAdapter {

	public idFile: number;

	constructor(
		private etlClient: Service
	) { super() }

	getColumns() {
		return [
			{width: 120},
			{width: null},
		];
	}

	async getControls() {
		const file = this.idFile ? (
			await this.etlClient.get<File>(`files/${this.idFile}`)
		) : {};
		
		return [
			{row: 0, col: 0, type: FormControlType.Label, value: msg('File'), for: 'input_file'},
			{row: 0, col: 1, type: FormControlType.TextInput, key: 'input_file', value: file.input_file, required: true},
			{row: 1, col: 0, type: FormControlType.Label, value: msg('Type'), for: 'type'},
			{row: 1, col: 1, type: FormControlType.List, value: file.type, key: 'type', required: false, content: {
				sourceData: [{k: 'CSV', v: 'csv'}], options: {selectMode: 'single', autoClose: true, allowEmpty: true}
			}},
			{row: 2, col: 0, type: FormControlType.Label, value: msg('Description'), for: 'description'},
			{row: 2, col: 1, type: FormControlType.TextInput, key: 'description', value: file.description, required: false},
			{row: 3, col: 0, type: FormControlType.Label, value: msg('Expiration')},
			{row: 3, col: 1, type: FormControlType.TextInput, key: 'expiration', value: file.expiration_min, required: false},
			{row: 4, col: 0, type: FormControlType.Label, value: 'Sync'},
			{row: 4, col: 1, type: FormControlType.Checkbox, key: 'sync', value: file.sync},

			{row: 5, col: 0, type: FormControlType.Label, value: `CSV ${msg('delimiter')}`},
			{row: 5, col: 1, type: FormControlType.List, value: file.delimiter, key: 'delimiter', required: false, content: {
				sourceData: delimiters.map(([k, v]) => ({k, v})), options: {selectMode: 'single', autoClose: true, allowEmpty: true}
			}},
			{row: 6, col: 0, type: FormControlType.Label, value: `CSV ${msg('enclosure')}`},
			{row: 6, col: 1, type: FormControlType.List, value: file.enclosure, key: 'enclosure', required: false, content: {
				sourceData: quotes.map(([k, v]) => ({k, v})), options: {selectMode: 'single', autoClose: true, allowEmpty: true}
			}},
			{row: 7, col: 0, type: FormControlType.Label, value: `CSV ${msg('header')}`},
			{row: 7, col: 1, type: FormControlType.Checkbox, key: 'header', value: file.header},

			{row: 8, col: 0, type: FormControlType.Label, value: msg('Encoding')},
			{row: 8, col: 1, type: FormControlType.List, value: file.encoding, key: 'encoding', required: false, content: {
				sourceData: encodings.map(v => ({k: v, v})), options: {selectMode: 'single', autoClose: true, allowEmpty: true}
			}},

			// METADATA governs whether METADATA_DEFINITION is used at all: p_ETL_EXEC_THREAD /
			// p_ETL_LOAD_FILE read the definition only when the flag is 1, otherwise the column
			// declaration is derived from the CSV header of the physical file
			{row: 9, col: 0, type: FormControlType.Label, value: msg('Use metadata')},
			{row: 9, col: 1, type: FormControlType.Checkbox, key: 'metadata', value: file.metadata}
		];
	}

	getOptions(): FormContainerOptions {
		return {
			caption: null,
			buttonsPosition: 'bottom',
			alertsPosition: 'bottom',
			buttons: ["save", "close"]
		};
	}

	async save(values: Map<string|number, FormValues>): Promise<boolean|FormAlert[]> {
		const formValues = values.get(0);
		const file: File = {
			id_file: this.idFile,
			input_file: formValues.input_file as string,
			description: formValues.description as string,
			type: formValues.type as string,
			expiration_min: parseInt(formValues.expiration as string) || 0,
			sync: formValues.sync == '1',
			metadata: formValues.metadata == '1',
			header: formValues.header == '1',
			delimiter: formValues.delimiter as string,
			enclosure: formValues.enclosure as string,
			encoding: formValues.encoding as string
		};
		await this.etlClient.post(`files`, file);
		return true;
		// return [{text: 'Error', type: 'danger'}];
	}
};
